<template>
	<div class="visachoice">
		<back-to></back-to>
		<section class="choiceDate">
			<van-calendar title="日期选择" :formatter="formatter" :poppable="false" :show-confirm="false"
				class="choiceDate-calendar" @select="select" :default-date="defaultDate" />
		</section>
		<!-- 类型和数量 -->
		<section class="choiceNum">
			<div class="choiceNum-num">
				<h2>购买数量</h2>
				<div class="choiceNum-num-n">
					<span>数量</span>
					<span>
						<p class="btn btn-minus" @click="sub"></p>
						<font>{{num}}</font>
						<p class="btn btn-plus" @click="add"></p>
					</span>
				</div>
			</div>
		</section>
		<!-- 底部 -->
		<section class="choiceBtn">
			<div class="choiceBtn-l">
				<p>价格:</p>
				<font>￥{{total}}</font>
			</div>
			<div class="choiceBtn-r" @click="goto">填写信息</div>
		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	import {
		formatTime
	} from "@/config/util";
	import {
		Dialog
	} from 'vant'
	export default {
		name: 'visachoice',
		components: {
			BackTo
		},
		data() {
			return {
				num: 1,
				price: 0,
				total: 0,
				workDays: 0,
				id: 0,
				defaultDate: null,
				startday: ""
			}
		},
		created() {
			this.id = this.$route.query.id
			this.total = this.$route.query.price
			this.price = this.$route.query.price
			this.workDays = this.$route.query.workDays
			let timestamp = (Number(this.$route.query.workDays) + 1) * 1000 * 60 * 60 * 24;
			this.defaultDate = new Date(new Date().getTime() + timestamp)
			this.startday = formatTime(this.defaultDate)
		},
		mounted() {

		},
		methods: {
			goto() {
				if (this.time == '') {
					Dialog.alert({
						message: '请选择套餐日期',
					}).then(() => {});
					return false
				}

				let orderParam = {}
				orderParam.id = this.id
				orderParam.startday = this.startday
				orderParam.price = this.price
				orderParam.count = this.num
				orderParam.total = this.total

				this.$router.push({
					path: '/visaorder',
					query: {
						orderParam: JSON.stringify(orderParam)
					}
				})
			},
			sub() {
				if (this.num <= 1) {
					this.num = 1
				} else {
					this.num = this.num - 1
					this.total = this.num * parseFloat(this.price)
				}
			},
			add() {
				this.num = this.num + 1
				this.total = this.num * parseFloat(this.price)
			},
			select(e) {
				let timestamps = this.$route.query.workDays * 1000 * 60 * 60 * 24
				if (new Date(e).getTime() >= new Date().getTime() + timestamps) {
					this.startday = formatTime(e)
				} else {
					Dialog.alert({
						message: '该日期不可选',
					}).then(() => {
						let timestamp = (Number(this.$route.query.workDays) + 1) * 1000 * 60 * 60 * 24;
						this.defaultDate = new Date(new Date().getTime() + timestamp)
					});

				}
			},
			formatter(day) {
				let timestamp = new Date().getTime();
				timestamp = timestamp + this.workDays * (1000 * 60 * 60 * 24);
				if (day.date.getTime() >= timestamp) {
					day.bottomInfo = '￥' + this.price
				}
				return day;
			}

		}
	}
</script>

<style>
	.choiceDate-calendar {
		height: 890px;
	}

	.choiceDate .van-calendar__header-title {
		height: 80px;
		line-height: 80px;
		color: #000;
		font-size: 32px;
		background: #f6f6f6;
		text-align: left;
		padding-left: 32px;
		box-sizing: border-box;
	}

	.choiceDate .van-calendar__weekdays {
		background-color: #ff8a00;
		color: #fff;
	}

	.choiceDate .van-calendar__selected-day {
		background-color: rgba(255, 109, 0, .3);
		color: #ff6d00;
	}

	.choiceDate .van-calendar__bottom-info {
		color: #ff6d00;
	}

	.choiceNum {
		width: 100%;
		padding: 10px 42px;
		box-sizing: border-box;
		padding-bottom: 160px;
	}

	.choiceNum h2 {
		font-size: 33px;
		font-weight: normal;
	}


	.choiceNum-num-n {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		margin-top: 40px;
	}

	.choiceNum-num-n span {
		display: flex;
		align-items: center;
	}

	.choiceNum-num-n font {
		display: inline-block;
		background: #fef6f1 no-repeat center;
		width: 84px;
		height: 45px;
		line-height: 45px;
		color: #666;
		text-align: center;
		font-size: 28px;
	}

	.btn {
		display: inline-block;
		background: #FFF no-repeat center;
		width: 64px;
		height: 45px;
		border-radius: 2px;
		box-shadow: 0 1px rgba(100, 100, 100, .1);
		color: #666;
		transition: color .2s, background-color .2s;

	}

	.btn-minus {
		background-image: linear-gradient(to top, currentColor, currentColor);
		height: 45px;
		background-size: 25px 4px;
	}

	.btn-plus {
		background-image: linear-gradient(to top, currentColor, currentColor), linear-gradient(to top, currentColor, currentColor);
		background-size: 25px 4px, 4px 25px;
	}

	.choiceBtn {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 96px;
		border-top: 1px solid #e5e4e3;
		background-color: #fff;
	}

	.choiceBtn div {
		height: 96px;
		display: flex;
		align-items: center;
	}

	.choiceBtn-r {
		width: 286px;
		background: #ff6d00;
		font-size: 36px;
		color: #fff;
		border: 0;
		justify-content: center;
	}

	.choiceBtn-l {
		color: #ff6d00;
		font-size: 48px;
		display: inline-block;
		padding-left: 28px;
		box-sizing: border-box;
	}

	.choiceBtn-l p {
		font-size: 28px;
		color: #333;
		margin-top: 12px;
		padding-right: 7px;
	}
</style>
